/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import e from "../../core/Logger.js";
import r from "../ClassBreaksRenderer.js";
import s from "../DictionaryRenderer.js";
import t from "../DotDensityRenderer.js";
import o from "../HeatmapRenderer.js";
import n from "../PieChartRenderer.js";
import i from "../Renderer.js";
import a from "../SimpleRenderer.js";
import l from "../UniqueValueRenderer.js";
const m = {
    key: "type",
    base: i,
    typeMap: {
      heatmap: o,
      simple: a,
      "unique-value": l,
      "class-breaks": r,
      "dot-density": t,
      dictionary: s,
      "pie-chart": n
    },
    errorContext: "renderer"
  },
  u = {
    key: "type",
    base: i,
    typeMap: {
      simple: a,
      "unique-value": l,
      "class-breaks": r,
      heatmap: o
    },
    errorContext: "renderer",
    validate: p
  };
function p(e) {
  switch (e.type) {
    case "simple":
      return c(e);
    case "unique-value":
      return f(e);
    case "class-breaks":
      return d(e);
    case "heatmap":
      return e;
  }
}
function c(r) {
  if (r.symbol) return r;
  e.getLogger("esri.renderers.support.types").error("Removed invalid 'simple' renderer without a symbol from web scene.");
}
function f(r) {
  const s = r.uniqueValueInfos,
    t = s?.filter(({
      symbol: r,
      label: s
    }, t) => (r || e.getLogger("esri.renderers.support.types").error(`Removed invalid unique value info ([${t}] ${s}) without a symbol from web scene.`), !!r));
  return t?.length !== s?.length && (r.uniqueValueInfos = t), r;
}
function d(r) {
  const s = r.classBreakInfos,
    t = s?.filter(({
      symbol: r,
      label: s
    }, t) => (r || e.getLogger("esri.renderers.support.types").error(`Removed invalid class break info ([${t}] ${s}) without a symbol from web scene.`), !!r));
  return t?.length !== s?.length && (r.classBreakInfos = t), r;
}
export { m as rendererTypes, u as webSceneRendererTypes };